import "@/App.css";
import React, { Suspense, lazy } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { CMSProvider } from "@/context/CMSContext";

// Landing page loaded eagerly (main page - no delay)
import LandingPage from "@/pages/LandingPage";

// Lazy load all secondary pages
const ThankyouPage = lazy(() => import("./pages/ThankyouPage"));
const PMaxLandingPage = lazy(() => import("@/pages/PMaxLandingPage"));

// Lazy load secondary pages only
const AdminDashboard = lazy(() => import("@/pages/AdminDashboard"));
const ApplicationPage = lazy(() => import("@/pages/ApplicationPage"));
const PrivacyPolicy = lazy(() => import("@/pages/PrivacyPolicy"));

// Minimal loading fallback for lazy routes
const PageLoader = () => (
  <div className="min-h-screen flex items-center justify-center" style={{background: '#fdf2f4'}}>
    <div className="text-center">
      <div style={{width: '48px', height: '48px', border: '4px solid #7a2d3d', borderTopColor: 'transparent', borderRadius: '50%', animation: 'spin 1s linear infinite', margin: '0 auto 16px'}} />
      <p style={{color: '#666'}}>Loading...</p>
    </div>
    <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
  </div>
);

function App() {
  return (
    <div className="App min-h-screen bg-background">
      <CMSProvider>
        <BrowserRouter>
          <Routes>
            {/* Main landing page - no Suspense wrapper for instant load */}
            <Route path="/" element={<LandingPage />} />
            
            {/* PMax campaign page - OTP verified leads */}
            <Route path="/pmax" element={
              <Suspense fallback={<PageLoader />}>
                <PMaxLandingPage />
              </Suspense>
            } />
            
            {/* Secondary pages - lazy loaded with spinner */}
            <Route path="/admin" element={
              <Suspense fallback={<PageLoader />}>
                <AdminDashboard />
              </Suspense>
            } />
            <Route path="/apply" element={
              <Suspense fallback={<PageLoader />}>
                <ApplicationPage />
              </Suspense>
            } />
            <Route path="/thank-you" element={
              <Suspense fallback={<PageLoader />}>
                <ThankyouPage />
              </Suspense>
            } />
            <Route path="/privacy-policy" element={
              <Suspense fallback={<PageLoader />}>
                <PrivacyPolicy />
              </Suspense>
            } />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </CMSProvider>
    </div>
  );
}

export default App;
